<template>
  <div id="reservationslist">
    <div class="help">
      <span class="help-icon" @click="helpCliked()">
        <i class="icon-question-sign" v-if="!help_cliked"></i>
        <i class="icon-circledelete" v-if="help_cliked"></i>
      </span>
      <div class="help_information" v-if="help_cliked">
        <h2 class="helpH2">月末報告の仕方</h2>
        <table>
          <tr>
            <td>
              <ol class="helpO2">
                <li>①発行したい生徒を選択する</li>
                <li>②発行したい月を選択する</li>
                <li>③データを記入したいスプレッドシートのIDをコピーペーストする。</li>
                <li>④データを記入したいスプレッドシートのシート名を記入する。</li>
                <li>⑤発行ボタンを押す。</li>
              </ol>
            </td>
            <td><img src="../../assets/img/報告書説明.png" style="width: 100%;"></td>
          </tr>
        </table>
      </div>
    </div>
    <table>
      <tr>
        <td>
          <el-select v-model="studentname" placeholder="生徒名">
          <el-option
            v-for="item in lectureInfo"
            :key="item.student.id"
            :label="item.student.fullname"
            :value="item.student.id">
          </el-option>
        </el-select>
        </td>
        <td>
          <el-date-picker
            v-model="month"
            type="month"
            value-format="yyyy-MM"
            placeholder="月を選択してください">
          </el-date-picker>
        </td>
        <td>
          <el-input placeholder="Sheets ID" v-model="SheetsID"></el-input>
        </td>
        <td>
          <el-input placeholder="シート名" v-model="SheetsName"></el-input>
        </td>
        <td>
          <el-button type="primary" icon="el-icon-upload" @click="sendtoGCP()">発行</el-button>
        </td>
      </tr>
    </table>
    <el-table
      v-loading="loading"
     :data="reservationlist"
     style="width: 80%; margin: 0 auto">
     <el-table-column
       prop="date"
       label="日付"
       width="180">
     </el-table-column>
     <el-table-column
       prop="start_time"
       label="開始時刻"
       width="150">
     </el-table-column>
     <el-table-column
       prop="end_time"
       label="終了時刻"
       width="150">
     </el-table-column>
     <el-table-column
       prop="student.fullname"
       label="氏名">
     </el-table-column>
     <el-table-column
       prop="classroom"
       label="教室">
     </el-table-column>
   </el-table>
  </div>
</template>

<script>
import arraysort from 'array-sort'

import {
  mapActions
} from 'vuex'

export default {
  name: 'reservationslist',
  data () {
    return {
      help_cliked: false,
      month: null,
      sheetsID: null,
      reservationlist: [],
      lectureInfo: null,
      studentname: '',
      SheetsID: '',
      SheetsName: '',
      loading: false
    }
  },
  methods: {
    ...mapActions([
      'getLectures',
      'getReservations',
      'exportRport'
    ]),
    success () {
      this.$notify({
        title: '成功',
        message: 'スプレッドシートへの記入に成功しました',
        type: 'success',
        offset: 50
      })
    },
    errorM () {
      this.$notify({
        title: '失敗',
        message: 'スプレッドシートへの記入に失敗しました',
        type: 'error',
        offset: 50
      })
    },
    helpCliked () {
      if (!this.help_cliked) {
        this.help_cliked = true
      } else {
        this.help_cliked = false
      }
    },
    showTable () {
      this.loading = true
      this.getReservations({
        user_id: this.$store.state.userInfo.user_id,
        school_id: this.$store.state.userInfo.school_id
      }).then(() => {
        // いた場合
        this.reservationlist = this.$store.state.reservations
        this.reservationlist = this.reservationlist.filter(
          (v) => ((v.student.id === this.studentname) && (v.date.match(this.month)))
        )
        this.reservationlist = arraysort(this.reservationlist, 'date')
        this.loading = false
      })
    },
    sendtoGCP () {
      if (confirm('内容をスプレッドシートに入力しますか?')) {
        this.loading = true
        var sendData = {
          'ID': this.SheetsID,
          'sheetsName': this.SheetsName,
          'date': this.reservationlist
        }
        this.exportRport(sendData).then((res) => {
          if (res.status === 200) {
            this.success()
          } else {
            this.errorM()
          }
          this.loading = false
        })
      }
    }
  },
  created () {
    this.$store.dispatch('getLectures', {})
    this.lectureInfo = this.$store.state.lectureInfo
  },
  watch: {
    month: function () {
      if (this.studentname) {
        this.showTable()
      }
      var yaer = Number(this.month.slice(0, 4))
      var mon = Number(this.month.slice(5, 8))
      var name = String(yaer) + '年' + String(mon) + '月'
      this.SheetsName = name
    },
    studentname: function () {
      if (this.month) {
        this.showTable()
      }
    }
  }
}
</script>

<style scoped>
table {
  margin: 0 auto;
}
.help {
  width: auto;
  float: right;
  position: fixed;
  z-index: 100;
  top: 90px;
  right: 10px;
}
.help-icon{
  color: #ffd500;
  font-size: 50px;
}
.help-icon :hover{
  color: #E69200;
}
.help_information{
  width: auto;
  float: right;
  position: fixed;
  z-index: 100;
  top: 80px;
  right: 60px;
  background-size: cover;
  background-color: rgba(255, 255, 255);
  border: solid 3px #6091d3;
  border-radius: 10px;
}
.message{
  background-color: red;
}
</style>



// WEBPACK FOOTER //
// ReservationList.vue?4bf69844